import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CoreData } from "src/app/tools/core-data/core-data";
import { LoadingTask } from "src/app/tools/ui/loading-task";
import { environment } from "src/environments/environment";
import { BaseService } from "../base-service";
import { catchError, finalize, map } from "rxjs/operators";
import { MeasureReference } from "src/app/domain/GS/measure-reference";

@Injectable({
    providedIn: 'root',
})
export class MeasureReferenceService extends BaseService {

    private serviceUrl = `${environment.GSServiceBaseUrl}api/masterdata`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    getAllMeasureReferences() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/allmeasurereferences`, this.generateHeaderWithBearer(environment.GSBearer)).pipe(
            catchError(this.handleError<any>('getAllMeasureReferences')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: MeasureReference[]) => {
                return response.map((item: MeasureReference) => {
                    return MeasureReference.mapFromJSON(item);
                });
            }));
    }
}